/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name KeystoneIsEnabledCollDataSource
 * @description
 *
 *     Regular CollDataSource, only difference is the fact there is no need to load it when
 *     collection has no entries.
 *
 **/
angular.module('aviApp').factory('KeystoneIsEnabledCollDataSource', [
'CollDataSource', function(CollDataSource) {
    return class KeystoneIsEnabledCollDataSource extends CollDataSource {
        /** @override */
        isInactive() {
            return !this.owner_.getNumberOfItems();
        }
    };
}]);
